import { useState } from 'react';
import PropTypes from 'prop-types';

import linkIcon from 'assets/link_icon.svg';

import copyValue from 'utlis/copy_value';
import { errorReactToastify, successReactToastify } from 'utlis/toasts';

const ShareReviewModal = ({ isOpen, onClose, reviewUuid }) => {
  const [shareableLink] = useState(`${location.origin}/share/${reviewUuid}`);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await copyValue(shareableLink);
      setIsCopied(true);
      successReactToastify('Link copied to clipboard!');
    }
    catch (error) {
      errorReactToastify('Failed to copy link to clipboard');
    }
  };

  // Reset copied state when modal closes
  const handleClose = () => {
    setIsCopied(false);
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 9999, backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
    >
      <div
        className="absolute inset-0 bg-gray-900 bg-opacity-30"
        onClick={handleClose}
      />

      <div className="relative flex flex-col items-start bg-white border border-gray-200 rounded-2xl shadow-lg">
        <div className="flex justify-between w-full px-24 py-16">
          <h2 className="h-5 font-semibold text-base leading-5 text-gray-900">
            Share this review
          </h2>
          <button
            onClick={handleClose}
            className="w-5 h-5 flex items-center justify-center"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M15 5L5 15M5 5l10 10" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div className="flex flex-col items-start w-full border-b border-t border-gray-200">
          <div className="flex items-center mx-24 my-24 h-14 bg-white border border-gray-300 rounded-lg px-16 py-12">
            <div>
              <img src={linkIcon} alt="Link" className="w-full h-full" style={{ transform: 'rotate(-50deg)' }} />
            </div>
            <div className="flex-1 text-sm leading-5 text-gray-900 truncate ml-8 mr-8">
              {shareableLink}
            </div>
            <button
              onClick={handleCopyLink}
              className="flex items-center justify-center px-12 py-8 bg-primary-500 rounded-lg"
              style={{ width: '100px' }}
            >
              <span className="h-4 text-xs leading-4 text-white">
                {isCopied ? 'Link copied!' : 'Copy link'}
              </span>
            </button>
          </div>
        </div>
        <div className="flex items-center px-24 py-16">
          <span className="font-normal text-sm leading-5 text-gray-600">
            Anyone with the link can view
          </span>
        </div>
      </div>
    </div>
  );
};

ShareReviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  reviewUuid: PropTypes.string.isRequired,
};

export default ShareReviewModal;
